import { v4 as uuidv4 } from 'uuid'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga'
import { postAnalytics } from '../services/analytics'
import useConfigContext from './useConfigContext'

const usePageTracking = () => {
  const location = useLocation()
  const { customerConfig } = useConfigContext()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const urlPermanentId = searchParams.get('permanent_id')
    const storedPermanentId = localStorage.getItem('permanent_id')
    if (urlPermanentId && urlPermanentId !== storedPermanentId) {
      localStorage.setItem('permanent_id', urlPermanentId)
    }
    if (!storedPermanentId && !urlPermanentId) {
      const newId = uuidv4()
      localStorage.setItem('permanent_id', newId)
    }
    ReactGA.initialize(customerConfig.gtmId)
    setInitialized(true)
  }, [])

  useEffect(() => {
    if (initialized) {
      ReactGA.pageview(location.pathname + location.search)
      const [, pagePath] = location.pathname.split('/')
      postAnalytics({
        category: 'pageviews',
        data: {
          page_title: pagePath || 'homepage',
          customer: customerConfig.customer,
        },
      })
    }
  }, [initialized, location])
}

export default usePageTracking
